import { Button, Divider, Flex, FormControl, FormLabel, HStack, Heading, IconButton, Input, Select, SimpleGrid, Stack, Text } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';

import { FiArrowLeft } from 'react-icons/fi';
import GooglePlacesAutocomplete from 'react-google-places-autocomplete';
import { addPickupPoint } from '../../store/actions';
import { useAppDispatch } from '../../hooks';
import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';

export const AddPickupPoint = () => {

    const [origin, setOrigin] = useState<any | null>(null);

    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const addPickupPointForm = useFormik({
        initialValues: {
            name: '',
            address: '',
            email: '',
            phone: '',
            is_active: true,
            operating_hours: {
                monday: {
                    open: '-',
                    close: '-'
                },
                tuesday: {
                    open: '-',
                    close: '-'
                },
                wednesday: {
                    open: '-',
                    close: '-'
                },
                thursday: {
                    open: '-',
                    close: '-'
                },
                friday: {
                    open: '-',
                    close: '-'
                },
                saturday: {
                    open: '-',
                    close: '-'
                },
                sunday: {
                    open: '-',
                    close: '-'
                },
            }
        },
        validateOnBlur: true,
        onSubmit: (values) => {
            addPickupPointForm.setSubmitting(true);
            dispatch(addPickupPoint({ ...values, address: origin?.label }))
                .then(() => navigate('/pickup-points'))
                .finally(() => addPickupPointForm.setSubmitting(false));
        }
    });

    useEffect(() => {
    }, []);

    return (
        <>
            <Flex
                minH={'-webkit-fill-available'}
                align={'center'}
                justify={'center'}
                pt={2}
                pb={10}
            >
                <Stack bgColor={'white'} borderRadius={6} p={6}>
                    <HStack spacing={6}>
                        <IconButton
                            aria-label={'Go back'}
                            icon={<FiArrowLeft />}
                            onClick={() => navigate('/pickup-points')}
                        />
                        <Heading size={'md'}>Add Pickup Point.</Heading>
                    </HStack>
                    <Divider py={2} />
                    <Stack pt={4}>
                        <form onSubmit={addPickupPointForm.handleSubmit}>
                            <FormControl mb={3} isRequired>
                                <FormLabel>Name</FormLabel>
                                <Input
                                    name='name'
                                    type='text'
                                    value={addPickupPointForm.values.name}
                                    onChange={addPickupPointForm.handleChange}
                                    onBlur={addPickupPointForm.handleBlur}
                                />
                                {addPickupPointForm.errors.name && <Text fontSize='sm' color='red.400'>{addPickupPointForm.errors.name}</Text>}
                            </FormControl>
                            <FormControl mb={3} isRequired>
                                <FormLabel>Address</FormLabel>
                                <GooglePlacesAutocomplete
                                    apiKey='AIzaSyCsvDO2ZMssvwhcmIo2TqXvJSL0zlMD5bw'
                                    apiOptions={{ region: 'za' }}
                                    selectProps={{
                                        placeholder: 'Address',
                                        origin,
                                        onChange: setOrigin,
                                    }}
                                />
                                {/* <Input name='address' type="text" value={companyForm.values.address} onChange={companyForm.handleChange} /> */}
                                {!origin?.label && <Text fontSize='sm' color='red.400'>{'Enter your address'}</Text>}
                            </FormControl>
                            <FormControl mb={3} isRequired>
                                <FormLabel>Email</FormLabel>
                                <Input
                                    name='email'
                                    type='email'
                                    value={addPickupPointForm.values.email}
                                    onChange={addPickupPointForm.handleChange}
                                    onBlur={addPickupPointForm.handleBlur}
                                />
                                {addPickupPointForm.errors.email && <Text fontSize='sm' color='red.400'>{addPickupPointForm.errors.email}</Text>}
                            </FormControl>
                            <SimpleGrid columns={[1, 2, 2, 2, 2]} spacing={3}>
                                <FormControl mb={3} isRequired>
                                    <FormLabel>Phone</FormLabel>
                                    <Input
                                        name='phone'
                                        type='text'
                                        maxW={'350px'}
                                        value={addPickupPointForm.values.phone}
                                        onChange={addPickupPointForm.handleChange}
                                        onBlur={addPickupPointForm.handleBlur}
                                    />
                                    {addPickupPointForm.errors.phone && <Text fontSize='sm' color='red.400'>{addPickupPointForm.errors.phone}</Text>}
                                </FormControl>
                                <FormControl isRequired>
                                    <FormLabel>Active</FormLabel>
                                    <Select name='is_active' value={`${addPickupPointForm.values.is_active}`} onChange={addPickupPointForm.handleChange} onBlur={addPickupPointForm.handleBlur}>
                                        <option value={'true'}>True</option>
                                        <option value={'false'}>False</option>
                                    </Select>
                                    {addPickupPointForm.errors.is_active && <Text color={'red.500'} fontSize={'sm'}>{addPickupPointForm.errors.is_active}</Text>}
                                </FormControl>
                            </SimpleGrid>
                            <Divider my={3} />
                            <Text fontWeight={'semibold'}>Operating hours</Text>
                            <SimpleGrid mt={3} columns={[1, 2, 2, 2, 2]} spacing={4}>
                                <HStack justifyContent={'space-between'}>
                                    <Stack>
                                        <Text>Monday</Text>
                                    </Stack>
                                    <HStack>
                                        <Input
                                            placeholder=''
                                            size='sm'
                                            type='time'
                                            name='operating_hours.monday.open'
                                            value={addPickupPointForm.values.operating_hours.monday.open}
                                            onChange={addPickupPointForm.handleChange}
                                            onBlur={addPickupPointForm.handleBlur}
                                        />
                                        <Text>-</Text>
                                        <Input
                                            placeholder=''
                                            size='sm'
                                            type='time'
                                            name='operating_hours.monday.close'
                                            value={addPickupPointForm.values.operating_hours.monday.close}
                                            onChange={addPickupPointForm.handleChange}
                                            onBlur={addPickupPointForm.handleBlur}
                                        />
                                    </HStack>
                                </HStack>
                                <HStack justifyContent={'space-between'}>
                                    <Stack>
                                        <Text>Tuesday</Text>
                                    </Stack>
                                    <HStack>
                                        <Input
                                            placeholder=''
                                            size='sm'
                                            type='time'
                                            name='operating_hours.tuesday.open'
                                            value={addPickupPointForm.values.operating_hours.tuesday.open}
                                            onChange={addPickupPointForm.handleChange}
                                            onBlur={addPickupPointForm.handleBlur}
                                        />
                                        <Text>-</Text>
                                        <Input
                                            placeholder=''
                                            size='sm'
                                            type='time'
                                            name='operating_hours.tuesday.close'
                                            value={addPickupPointForm.values.operating_hours.tuesday.close}
                                            onChange={addPickupPointForm.handleChange}
                                            onBlur={addPickupPointForm.handleBlur}
                                        />
                                    </HStack>
                                </HStack>
                                <HStack justifyContent={'space-between'}>
                                    <Stack>
                                        <Text>Wednesday</Text>
                                    </Stack>
                                    <HStack>
                                        <Input
                                            placeholder=''
                                            size='sm'
                                            type='time'
                                            name='operating_hours.wednesday.open'
                                            value={addPickupPointForm.values.operating_hours.wednesday.open}
                                            onChange={addPickupPointForm.handleChange}
                                            onBlur={addPickupPointForm.handleBlur}
                                        />
                                        <Text>-</Text>
                                        <Input
                                            placeholder=''
                                            size='sm'
                                            type='time'
                                            name='operating_hours.wednesday.close'
                                            value={addPickupPointForm.values.operating_hours.wednesday.close}
                                            onChange={addPickupPointForm.handleChange}
                                            onBlur={addPickupPointForm.handleBlur}
                                        />
                                    </HStack>
                                </HStack>
                                <HStack justifyContent={'space-between'}>
                                    <Stack>
                                        <Text>Thursday</Text>
                                    </Stack>
                                    <HStack>
                                        <Input
                                            placeholder=''
                                            size='sm'
                                            type='time'
                                            name='operating_hours.thursday.open'
                                            value={addPickupPointForm.values.operating_hours.thursday.open}
                                            onChange={addPickupPointForm.handleChange}
                                            onBlur={addPickupPointForm.handleBlur}
                                        />
                                        <Text>-</Text>
                                        <Input
                                            placeholder=''
                                            size='sm'
                                            type='time'
                                            name='operating_hours.thursday.close'
                                            value={addPickupPointForm.values.operating_hours.thursday.close}
                                            onChange={addPickupPointForm.handleChange}
                                            onBlur={addPickupPointForm.handleBlur}
                                        />
                                    </HStack>
                                </HStack>
                                <HStack justifyContent={'space-between'}>
                                    <Stack>
                                        <Text>Friday</Text>
                                    </Stack>
                                    <HStack>
                                        <Input
                                            placeholder=''
                                            size='sm'
                                            type='time'
                                            name='operating_hours.friday.open'
                                            value={addPickupPointForm.values.operating_hours.friday.open}
                                            onChange={addPickupPointForm.handleChange}
                                            onBlur={addPickupPointForm.handleBlur}
                                        />
                                        <Text>-</Text>
                                        <Input
                                            placeholder=''
                                            size='sm'
                                            type='time'
                                            name='operating_hours.friday.close'
                                            value={addPickupPointForm.values.operating_hours.friday.close}
                                            onChange={addPickupPointForm.handleChange}
                                            onBlur={addPickupPointForm.handleBlur}
                                        />
                                    </HStack>
                                </HStack>
                                <HStack justifyContent={'space-between'}>
                                    <Stack>
                                        <Text>Saturday</Text>
                                    </Stack>
                                    <HStack>
                                        <Input
                                            placeholder=''
                                            size='sm'
                                            type='time'
                                            name='operating_hours.saturday.open'
                                            value={addPickupPointForm.values.operating_hours.saturday.open}
                                            onChange={addPickupPointForm.handleChange}
                                            onBlur={addPickupPointForm.handleBlur}
                                        />
                                        <Text>-</Text>
                                        <Input
                                            placeholder=''
                                            size='sm'
                                            type='time'
                                            name='operating_hours.saturday.close'
                                            value={addPickupPointForm.values.operating_hours.saturday.close}
                                            onChange={addPickupPointForm.handleChange}
                                            onBlur={addPickupPointForm.handleBlur}
                                        />
                                    </HStack>
                                </HStack>
                                <HStack justifyContent={'space-between'}>
                                    <Stack>
                                        <Text>Sunday</Text>
                                    </Stack>
                                    <HStack>
                                        <Input
                                            placeholder=''
                                            size='sm'
                                            type='time'
                                            name='operating_hours.sunday.open'
                                            value={addPickupPointForm.values.operating_hours.sunday.open}
                                            onChange={addPickupPointForm.handleChange}
                                            onBlur={addPickupPointForm.handleBlur}
                                        />
                                        <Text>-</Text>
                                        <Input
                                            placeholder=''
                                            size='sm'
                                            type='time'
                                            name='operating_hours.sunday.close'
                                            value={addPickupPointForm.values.operating_hours.sunday.close}
                                            onChange={addPickupPointForm.handleChange}
                                            onBlur={addPickupPointForm.handleBlur}
                                        />
                                    </HStack>
                                </HStack>
                            </SimpleGrid>
                            <FormControl mt={3}>
                                <Button
                                    colorScheme={'yellow'}
                                    float={'right'}
                                    type={'submit'}
                                    isDisabled={addPickupPointForm.isSubmitting || !addPickupPointForm.isValid}
                                    isLoading={addPickupPointForm.isSubmitting}
                                >
                                    Submit
                                </Button>
                            </FormControl>
                        </form>
                    </Stack>
                </Stack>
            </Flex>
        </>
    );
};